// src/components/CustomFields/fields/InputTextField.tsx
// InputTextField component migrated from legacy

import React from 'react';
import CustomFieldsService from '../../../api/CustomFieldsService';
import ClickOutSide from '../../Globals/ClickOutSide';
import './InputTextField.css';
import type { BaseFieldProps, CustomFieldItem } from './types';

interface InputTextFieldState {
  value: string;
  EditorEnabled: boolean;
  editableValue: string;
  disableAutoSave: boolean;
  customField: CustomFieldItem;
  canEdit: boolean;
  apiConfig: { url: string; token: string };
}

class InputTextField extends React.Component<BaseFieldProps, InputTextFieldState>
{
  constructor(props: BaseFieldProps)
  {
    super(props);
    this.state = {
      value:
        props.customField.Value === null || props.customField.Value === undefined
          ? ''
          : String(props.customField.Value),
      EditorEnabled: props.EditorEnabled || false,
      editableValue: '',
      disableAutoSave: props.disableAutoSave || false,
      customField: props.customField,
      canEdit: props.canEdit && props.customField.ConversationIsEnable !== false,
      apiConfig: props.apiConfig,
    };

    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.enableEditor = this.enableEditor.bind(this);
    this.disableEditor = this.disableEditor.bind(this);
    this.onUpdateCustomField = this.onUpdateCustomField.bind(this);
  }

  componentWillReceiveProps(nextProps: BaseFieldProps)
  {
    // Only update if the value actually changed to prevent infinite loops
    const currentValue = String(this.state.customField.Value || '');
    const nextValue = String(nextProps.customField.Value || '');

    if (
      currentValue !== nextValue ||
      this.state.customField.CustomFieldId !== nextProps.customField.CustomFieldId
    )
    {
      this.setState({
        customField: nextProps.customField,
        value: nextProps.customField.Value === null ? '' : String(nextProps.customField.Value),
      });
    }
  }

  handleChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    this.setState({ value: event.target.value });
  }

  save()
  {
    const { value, editableValue, disableAutoSave } = this.state;

    const copyCustomField = { ...this.state.customField };

    // We make sure that the new value is different to the previous one
    if (value !== editableValue && value != null)
    {
      // Assign the new values
      copyCustomField.Value = value;
      copyCustomField.PreviousValue = editableValue;
      this.setState({ editableValue: value });

      this.disableEditor();

      // Do not save if autoSaved is disabled
      if (!disableAutoSave)
      {
        const requestSave = {
          api: this.props.apiConfig,
          request: copyCustomField,
        };

        if (
          copyCustomField.CustomFieldValueId === undefined ||
          copyCustomField.CustomFieldValueId === null ||
          copyCustomField.CustomFieldValueId === 0
        )
        {
          CustomFieldsService.savePost(requestSave).then((data: any) =>
          {
            copyCustomField.CustomFieldValueId = data.CustomFieldValueId;

            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
        else
        {
          CustomFieldsService.save(requestSave).then(() =>
          {
            try
            {
              this.setState({ customField: copyCustomField }, () =>
              {
                this.onUpdateCustomField();
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
      }
      else
      {
        // Disable the control
        this.disableEditor();

        this.setState({ customField: copyCustomField }, () =>
        {
          this.onUpdateCustomField();
        });
      }
    }
    else
    {
      // Disable the control
      this.disableEditor();
    }
  }

  enableEditor()
  {
    const { canEdit, value } = this.state;
    const { customField } = this.state;

    if (canEdit && customField.ConversationIsEnable !== false)
    {
      this.setState({ EditorEnabled: true, editableValue: value });
    }
  }

  disableEditor()
  {
    this.setState({ EditorEnabled: false });
  }

  onUpdateCustomField()
  {
    if (this.props.UpdateCustomFields)
    {
      this.props.UpdateCustomFields(this.state.customField);
    }
  }

  render()
  {
    const { EditorEnabled, canEdit, value, customField } = this.state;

    return (
      <div
        key={'cf-' + customField.CustomFieldId}
        className="corgee_com_custom-fields-field-A _DEL_field-A custom-field-id"
      >
        {customField.GroupMultiEditionType === 1 && (
          <i
            className="material-icons several-values enable-help-tooltip"
            title="Not all cards selected have this detail. The detail value will change only on applicable cards."
            data-title="Not all cards selected have this detail. The detail value will change only on applicable cards."
          >
            do_not_disturb_on
          </i>
        )}
        <span className="corgee_com_custom-fields-title _DEL_title">{customField.Name}</span>
        {!customField.GroupMultiEditionType && (
          <i
            className="material-icons not-filterable enable-help-tooltip"
            data-title="This detail type is not filterable"
          >
            do_not_disturb_on
          </i>
        )}

        <div className="click-to-edit">
          {!EditorEnabled ? (
            <div
              onClick={this.enableEditor}
              className={canEdit ? 'lbl-editable-input' : 'lbl-non-editable-input'}
            >
              {value !== undefined && value !== '' ? value : 'Not Set'}
            </div>
          ) : null}

          {EditorEnabled ? (
            <ClickOutSide onClickOutSide={this.save}>
              <div className="corgee_com_custom-fields-input-text">
                <div
                  className="ctrl-editable-input"
                  style={{ position: 'absolute', zIndex: 999999 }}
                >
                  <input
                    type="text"
                    onChange={this.handleChange}
                    onBlur={this.save}
                    value={value}
                    autoFocus
                  />
                </div>
              </div>
            </ClickOutSide>
          ) : null}
        </div>
      </div>
    );
  }
}

export default InputTextField;
